import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { Router, Route } from 'react-router';
import { createMemoryHistory } from 'history';
import App from './components';
import ConfirmPage from './components/confirmPage';
import FinishPage from './components/finishPage';
import Stores from './stores/index';

ReactDOM.render(
    <Provider stores={Stores}>
        <Router history={createMemoryHistory()}>
            <div>
                <Route exact path="/" component={App} />
                <Route exact path="/step2" component={ConfirmPage} />
                <Route exact path="/step3" component={FinishPage} />
            </div>
        </Router>
    </Provider>,
  document.getElementById('app'),
);
